import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import Rating from '@/components/base/Rating';
import { getGenreName } from '@/utils/movie';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block ${className}`}
      aria-label={`查看《${movie.title}》详情`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-100">
        <img
          src={movie.poster}
          alt={`${movie.title}电影海报`}
          title={`${movie.title} 电影海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-background-50/85 px-2 py-0.5 backdrop-blur-sm">
          <Rating value={movie.rating} size="sm" />
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-background-50/90 via-background-50/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-2xl text-foreground-950">
            <i className="ri-play-fill translate-x-0.5" aria-hidden="true" />
          </span>
        </div>
      </div>
      <h3 className="mt-3 line-clamp-1 font-heading text-sm font-bold text-foreground-100 transition-colors group-hover:text-primary-400 md:text-base">
        {movie.title}
      </h3>
      <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-foreground-500">
        <span>{movie.year}</span>
        <span className="text-foreground-700">·</span>
        <span className="line-clamp-1">{movie.genres.map((g) => getGenreName(g)).join(' ')}</span>
      </div>
    </Link>
  );
}